import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcGoodMark = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM14.1717 8.67175C14.5427 8.30075 14.5427 7.69925 14.1717 7.32825C13.8007 6.95725 13.1992 6.95725 12.8282 7.32825L8.99999 11.1565L7.17174 9.32825C6.80074 8.95725 6.19923 8.95725 5.82824 9.32825C5.45724 9.69925 5.45724 10.3008 5.82824 10.6718L8.32824 13.1718C8.69923 13.5427 9.30074 13.5427 9.67174 13.1718L14.1717 8.67175Z",
		fill: "#454952"
	})
});
export default SvgIcGoodMark;
